import { GridColDef } from '@mui/x-data-grid';
import { Button } from '@mui/material';
import { AdSpaceOwnerPackageInterface } from '../../../interfaces/interfaces';

export const getAdSpaceOwnerPackageColumns = (
  setPackageToDelete: (pkg: AdSpaceOwnerPackageInterface) => void,
  setDeleteDialogOpen: (open: boolean) => void,
  setPackageToUpdate: (pkg: AdSpaceOwnerPackageInterface) => void,
  setUpdateDialogOpen: (open: boolean) => void
): GridColDef[] => [
  { field: 'id', headerName: 'ID', width: 70 },
  { field: 'packageTotalPrice', headerName: 'Total Price', width: 130 },
  { field: 'userId', headerName: 'User ID', width: 100 },
  { field: 'notes', headerName: 'Notes', width: 200 },
  {
    field: 'adSpacesInThisPackage',
    headerName: 'Ad Spaces in package',
    width: 180,
    renderCell: (params) => {
      const value = params.row.adSpacesInThisPackage;
      if (Array.isArray(value)) {
        return value.join(', ');
      }
      return '-';
    },
  },
  { field: 'active', headerName: 'Active', width: 90, type: 'boolean' },
  { field: 'created_at', headerName: 'Created', width: 150 },
  { field: 'updated_at', headerName: 'Updated', width: 150 },
  {
    field: 'delete',
    headerName: 'Delete',
    width: 100,
    renderCell: (params) => (
      <Button
        color="error"
        variant="outlined"
        size="small"
        onClick={() => {
          setPackageToDelete(params.row);
          setDeleteDialogOpen(true);
        }}
      >
        Delete
      </Button>
    ),
    sortable: false,
    filterable: false,
  },
  {
    field: 'update',
    headerName: 'Update',
    width: 100,
    renderCell: (params) => (
      <Button
        color="primary"
        variant="outlined"
        size="small"
        onClick={() => {
          setPackageToUpdate(params.row);
          setUpdateDialogOpen(true);
        }}
      >
        Update
      </Button>
    ),
    sortable: false,
    filterable: false,
  },
];